if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // Mobile: use IntersectionObserver on product form
      const mobileObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          }
        });
      });
      if (this.productForm) mobileObserver.observe(this.productForm);

      // Desktop: use IntersectionObserver on the Add to Cart button for earlier trigger
      const desktopTarget = (this.productForm && this.productForm.querySelector('[name="add"]')) || this.productInfo;
      const desktopObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      }, { rootMargin: '-100px 0px 0px 0px' });
      if (desktopTarget) desktopObserver.observe(desktopTarget);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
